<template>
  <v-layout row fill-height>
    <v-tabs
      centered
      grow
      icons-and-text
      v-model="tabs"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab :key="'employeeTab'" class="primary--text">
        Mitarbeiter
        <v-icon>person</v-icon>
      </v-tab>
      <v-tab :key="'customerTab'" class="primary--text">
        Kunden
        <v-icon>group</v-icon>
      </v-tab>

      <v-tab-item
        :key="'employeeTab'"
      >
        <employee-invoice-list></employee-invoice-list>
      </v-tab-item>
      <v-tab-item
        :key="'customerTab'"
      >
        <customer-invoice-list></customer-invoice-list>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
  import EmployeeInvoiceList from './EmployeeInvoiceList'
  import CustomerInvoiceList from './CustomerInvoiceList'

  export default {
    name: 'Invoices',
    data () {
      return {
        tabs: null
      }
    },
    components: {
      'employee-invoice-list': EmployeeInvoiceList,
      'customer-invoice-list': CustomerInvoiceList
    }
  }
</script>

<style scoped>
  .v-tab {
    margin-left: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Invoices/Invoices.vue